module.exports = __webpack_public_path__ + "static/the-diving-bell-and-the-butterfly-409861da8a06840cf17285bcc1bc9f2d.jpg";